// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"619f0cd9","504":"dd993888","768":"072a6c8a"}[chunkId] + ".chunk.css";
};